import { useRef } from 'react';

const UNIQUE_PARAMS = ['page', 'sort'];

const useRouteParams = () => {
  const routeParamMap = useRef(new Map<string, Record<string, string>>());

  const getRouteParams = (route: string) => {
    const currentSearch = new URLSearchParams(window.location.search);
    const routeQuery = routeParamMap.current.get(route) || {};

    // Remove unique params from the current search params
    UNIQUE_PARAMS.forEach((param) => currentSearch.delete(param));

    // Merge route-specific params with the remaining search params
    Object.entries(routeQuery).forEach(([key, value]) =>
      currentSearch.set(key, value),
    );

    return currentSearch.toString();
  };

  const setRouteParams = (route: string, query?: string) => {
    const currentSearch = new URLSearchParams(query || window.location.search);
    const newQuery: Record<string, string> = {};

    // Extract unique params from the current query
    UNIQUE_PARAMS.forEach((param) => {
      const paramValue = currentSearch.get(param);

      if (paramValue) {
        newQuery[param] = paramValue;
      }
    });

    routeParamMap.current.set(route, newQuery);
  };

  return {
    getRouteParams,
    setRouteParams,
  };
};

export { useRouteParams };
